// @flow
const resultState: Object = {
  suggestions: [],
  loading: false,
  error: false,
  results: [],
  chosen: '',
};

export default resultState;
